const regModuleId = /^(?<n>(?:@(?<org>[a-z0-9-~][a-z0-9-._~]*)\/)?(?<pkg>[a-z0-9-~][a-z0-9-._~]*))(?:@(?<v>[-a-z0-9><=_.^~]+))?(?<p>\/[^\r\n]*)?$/;
function parseModuleId(s) {
  if (typeof s !== "string") {
    throw new Error(`invalid module id: ${s}`);
  }
  const groups = s.match(regModuleId)?.groups;
  if (!groups) {
    return void 0;
  }
  const { n: name, v: version, p: path, org, pkg } = groups;
  const scoped = Boolean(org);
  const v = /^\d+\.\d+\.\d+/.test(version) ? version : void 0;
  const range = version || "latest";
  const o = {
    id: `${name}@${range}`,
    name,
    range,
    scoped,
    pkg,
    org,
    versioned: Boolean(version)
  };
  if (v) {
    o.version = v;
  }
  if (path) {
    o.path = path;
  }
  if (!o.scoped) {
    delete o.org;
  }
  return o;
}

export { parseModuleId };
//# sourceMappingURL=parseModuleId.js.map
